import { createAppTheme } from "./createAppTheme";

const theme = createAppTheme();

export { createAppTheme };
export default theme;
